<template>
  <footer class="footer">
    <div class="container">
      <span class="text-muted">Copyright &copy; NNNCo {{(new Date()).getFullYear()}}</span>
    </div>
  </footer>
</template>

<script setup lang="ts">
// No script needed for this simple component
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
html {
  position: relative;
  min-height: 100%;
}
body {
  margin-bottom: 30px; /* Margin bottom by footer height */
}
.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 30px; /* Set the fixed height of the footer here */
  line-height: 30px; /* Vertically center the text there */
  background-color: #343a40 !important;
}

.text-muted {
  color: #149ead !important;
}
</style>